import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'administration.platform_manager.manager_management.title',
  },
  nameTitle: {
    id: 'administration.platform_manager.manager_management.table.name',
  },
  rolesTitle: {
    id: 'administration.platform_manager.manager_management.table.roles',
  },
  actionTitle: {
    id: 'administration.platform_manager.manager_management.table.action',
  },
  linesPerPage: {
    id: 'lines_per_page',
  },
  dialogTitle: {
    id: 'administration.platform_manager.manager_management.dialog_title',
  },
  toastManagerTitle: {
    id:
      'administration.platform_manager.manager_management.toast_update_manager_title',
  },
});
